// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';

axios.defaults.withCredentials = true;

// Attempt to fetch the current user profile (if a session exists)
store.dispatch('fetchUserProfile')
  .catch(err => {
    console.error('Error fetching user profile on app initialization:', err);
  })
  .finally(() => {
    createApp(App)
      .use(router)
      .use(store)
      .mount('#app');
  });

